import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import type { ComponentType } from 'react';
import type { IHistory } from '../history';
import { TYPES } from './private';

export interface IRouteActionResult {
    didLaunchAction: boolean;
    alternativeRouteSuggested?: string;
    alternativeRoutePayload?: Record<string, unknown>;
}

export interface IRoute<T> {
    paths: string[];
    push: (history: IHistory, props: T) => Promise<IRouteActionResult>;
    replace: (history: IHistory, props: T) => Promise<IRouteActionResult>;
    component: ComponentType<T>;
}

export interface IRouter {
    registerRoute: (name: string, route: IRoute<unknown>) => void;
    unregisterRoute: (name: string) => void;
    push: (name: string, args: unknown, options?: { replace?: boolean }) => void;
    popTo: (name: string) => boolean;
    pop: () => boolean;
    popCount: (num: number) => boolean;
    allRoutes: () => IRoute<unknown>[];
}

export function injectRouter(container: IContainer = injectOrBuildContainer()): IRouter {
    return container.get<IRouter>(TYPES.IRouter);
}

export function bindRouter(
    router: IRouter,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<IRouter>(TYPES.IRouter, router);
}

export function unbindRouter(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IRouter);
}
